import noUiSlider from 'nouislider';
// import '../../../node_modules/nouislider/dist/nouislider.css';
function init() {
    const form = document.querySelector('[data-module="form-filters"]');
    if (!form) return;
    // Deux entrées appellent init() indépendamment (theme.js via data-module,
    // et popup-filtre.js via import direct) : on empêche la double init pour
    // éviter que noUiSlider.create() plante sur un slider déjà initialisé,
    // ce qui casse tout le binding des clics/submit qui suit dans cette fonction.
    if (form.dataset.cdvFormFiltersInited === '1') return;
    form.dataset.cdvFormFiltersInited = '1';
    const resetButtons = document.querySelectorAll('.reload-filter');
    const resetAllButton = document.querySelector('.reset-filters');
    const links = document.querySelectorAll('.data-link');
    const toggles = document.querySelectorAll('.alm-filter--toggle');
    // find in form all with prop not checked/selected and ensure it
    form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
        if (input.hasAttribute('checked')) {
            input.checked = true;
        } else {
            input.checked = false;
        }
    });
    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const parent = toggle.closest('.alm-filter');
            const filters = parent.querySelector('.alm-filter--inner');
            const expanded = toggle.getAttribute('aria-expanded') === 'true' || (filters && filters.style.height !== '0px' && filters.style.height !== '');

            toggle.setAttribute('aria-expanded', !expanded);

            if (filters) {
                if (!expanded) {
                    // OPEN
                    filters.style.display = 'block';
                    const height = filters.scrollHeight;
                    filters.style.height = '0px';
                    // Force reflow pour que la transition parte de 0
                    filters.getBoundingClientRect();
                    filters.style.height = height + 'px';

                    filters.addEventListener('transitionend', () => {
                        filters.style.height = 'auto';
                    }, { once: true });
                } else {
                    // CLOSE — fixer la hauteur courante avant d'aller à 0
                    filters.style.height = filters.scrollHeight + 'px';
                    // Force reflow
                    filters.getBoundingClientRect();
                    filters.style.height = '0px';

                }
            }
        });
    });
    links.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault(); // au cas où

            const input = form.querySelector(`[name="${link.dataset.key}[]"][value="${link.dataset.value}"]`);

            const isEnvie = link.dataset.key === 'relations_envies';

            // Si le lien est déjà actif, on désactive juste LUI et son input, puis submit
            if (link.classList.contains('active')) {
                link.classList.remove('active');
                if (input) { input.checked = false; }
                display_loader();
                form.dispatchEvent(new Event('submit', { cancelable: true }));
                return;
            }

            // Envies : multi-sélection. Les autres data-link restent exclusifs.
            if (!isEnvie) {
                links.forEach(other => {
                    if (other.classList.contains('active')) {
                        other.classList.remove('active');
                        const otherInput = form.querySelector(`[name="${other.dataset.key}[]"][value="${other.dataset.value}"]`);
                        if (otherInput) otherInput.checked = false;
                    }
                });
            }

            link.classList.add('active');
            if (input) {
                input.checked = true;
            }

            display_loader();
            form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
    });
    if (resetAllButton) {
        resetAllButton.addEventListener('click', () => {
            display_loader();

            const url = new URL(window.location);
            url.search = '';
            window.history.pushState({}, '', url);
            window.location.reload();
        });
    }
    resetButtons.forEach(button => {
        button.addEventListener('click', () => {
            display_loader();

            const key = button.getAttribute('data-key');
            const value = button.getAttribute('data-value');

            const url = new URL(window.location);
            const params = new URLSearchParams(url.search);

            if (value.includes(',')) {
                // Range slider → supprimer la clé entière
                params.delete(key);
            } else if (params.has(key)) {
                // Checkbox / taxonomy → retirer une valeur du +
                const current = params.get(key);
                const updated = current.split('+').filter(v => v !== value);
                if (updated.length) {
                    params.set(key, updated.join('+'));
                } else {
                    params.delete(key);
                }
            }

            url.search = params.toString();
            window.history.pushState({}, '', url);
            window.location.reload();
        });
    });

    function display_loader() {
        $('.loader-filtre').fadeIn("slow");
        $('.list-filtres').hide();
        $('#product-grid').hide();
        $(".no-product").hide();
        const modal = document.getElementById('modal-filter');
        const pageActiveClass = 'offcanvas-opened';
        const modalActiveClass = 'modal-shown';
        modal.setAttribute('aria-hidden', 'true');
        modal.removeAttribute('aria-modal');
        modal.removeAttribute('role');
        modal.setAttribute('tabindex', '-1');

        // body

        document.body.classList.remove(pageActiveClass);
    }
    // on submit prevent default && ajax

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        // ── Désactiver les sliders à valeur par défaut ──────────────────────
        document.querySelectorAll('.cdv-range-slider').forEach(slider => {
            const inputs = slider.querySelectorAll('input[type="hidden"]');
            if (inputs.length < 2) return;
            const min = slider.dataset.min;
            const max = slider.dataset.max;

            if (inputs[0].value === min && inputs[1].value === max) {
                inputs[0].disabled = true;
                inputs[1].disabled = true;
            }
        });

        // ── Construire une URL propre sans [] ───────────────────────────────
        const formData = new FormData(form);
        const url = new URL(window.location);
        const params = new URLSearchParams();

        // Regrouper les valeurs par clé (sans les [])
        const grouped = {};
        display_loader();
        for (const [rawKey, value] of formData.entries()) {
            const key = rawKey.replace('[]', '');
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(value);
        }

        const previousEnvies = (new URLSearchParams(window.location.search).get('relations_envies') || '')
            .split('+')
            .filter(Boolean);

        for (const [key, values] of Object.entries(grouped)) {
            if (!values.length) continue;

            // Range slider → virgule (ex: prix_fourchette_basse=1350,75600)
            const slider = form.querySelector(`.cdv-range-slider input[name="${key}[]"]`);
            if (slider) {
                params.set(key, values.join(','));
            } else if (key === 'relations_envies') {
                // Dernière sélection en tête : nouveaux slugs prepend, retraits conservent l'ordre.
                const unique = [...new Set(values)];
                const kept = previousEnvies.filter((slug) => unique.includes(slug));
                const added = unique.filter((slug) => !previousEnvies.includes(slug));
                params.set(key, [...added.reverse(), ...kept].join('+'));
            } else {
                // Checkbox / taxonomy → + (ex: relations_types=croisiere+sejour)
                params.set(key, values.join('+'));
            }
        }
        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');

        url.search = params.toString();
        window.history.pushState({}, '', url);
        window.location.reload();
    });

    document.addEventListener('DOMContentLoaded', () => {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        let changed = false;

        document.querySelectorAll('.cdv-range-slider').forEach(slider => {
            const minInput = slider.querySelector('input[type="hidden"]');
            if (!minInput || !minInput.name) return;

            const key = minInput.name.replace('[]', '');
            const dataMin = slider.dataset.min;
            const dataMax = slider.dataset.max;

            if (params.get(key) === `${dataMin},${dataMax}`) {
                params.delete(key);
                changed = true;
            }
        });

        if (changed) {
            url.search = params.toString();
            window.history.replaceState({}, '', url);
        }
    });
    function formatRangeSliderLabels(slider, minVal, maxVal) {
        const valMin = slider.querySelector('.val-min');
        const valMax = slider.querySelector('.val-max');
        const plus = slider.querySelector('.cdv-range-slider__plus');
        const name = slider.querySelector('input[type="hidden"]')?.name?.replace('[]', '') || '';
        const cap = Math.round(parseFloat(slider.dataset.cap || slider.dataset.max));
        const rMin = Math.round(minVal);
        const rMax = Math.round(maxVal);

        if (plus) {
            plus.hidden = rMax < cap;
        }

        if (name === 'prix_fourchette_basse') {
            valMin.textContent = rMin.toLocaleString('fr-FR');
            valMax.textContent = rMax.toLocaleString('fr-FR');
            return;
        }

        valMin.textContent = String(rMin);
        valMax.textContent = String(rMax);
    }

    // sliders 
    document.querySelectorAll('.cdv-range-slider').forEach(slider => {
        const track = slider.querySelector('.cdv-range-slider__track');
        const inputs = slider.querySelectorAll('input[type="hidden"]');

        const min = parseFloat(slider.dataset.min);
        const max = parseFloat(slider.dataset.max);
        const step = parseFloat(slider.dataset.step);

        // 🟢 Correction ICI : valeur sélectionnée pour start
        const selectedMin = slider.dataset.selectedMin !== undefined ? parseFloat(slider.dataset.selectedMin) : min;
        const selectedMax = slider.dataset.selectedMax !== undefined ? parseFloat(slider.dataset.selectedMax) : max;

        noUiSlider.create(track, {
            start: [selectedMin, selectedMax],  // 🟢 ← synchronise ici
            connect: true,
            step: step,
            range: { min, max },
        });

        track.noUiSlider.on('update', (values) => {
            if (inputs.length >= 1) inputs[0].value = Math.round(values[0]);
            if (inputs.length >= 2) inputs[1].value = Math.round(values[1]);
            formatRangeSliderLabels(slider, values[0], values[1]);
        });
    });
    const resets = document.querySelectorAll('.alm-range-reset');

    resets.forEach(button => {
        const slider = button.closest('.cdv-range-slider');
        if (!slider) return;

        const track = slider.querySelector('.cdv-range-slider__track');
        const inputs = slider.querySelectorAll('input[type="hidden"]');
        if (!track || !track.noUiSlider || inputs.length < 2) return;
        const min = parseFloat(slider.dataset.min);
        const max = parseFloat(slider.dataset.max);

        // ✅ Caché par défaut
        button.style.display = 'none';

        // ✅ Afficher si le slider change
        track.noUiSlider.on('update', (values) => {
            const currentMin = parseFloat(values[0]);
            const currentMax = parseFloat(values[1]);
            const hasChanged = currentMin !== min || currentMax !== max;
            button.style.display = hasChanged ? 'inline-block' : 'none';
        });

        button.addEventListener('click', () => {
            // Reset noUiSlider
            track.noUiSlider.set([min, max]);

            // Reset hidden inputs
            inputs[0].value = min;
            inputs[1].value = max;

            // Reset affichage
            formatRangeSliderLabels(slider, min, max);

            // Retire les params GET correspondants
            const url = new URL(window.location);
            const params = new URLSearchParams(url.search);
            const name = inputs[0].name.replace('[]', '');

            params.delete(name + '[]');
            params.delete(name + '_min');
            params.delete(name + '_max');

            url.search = params.toString();
            window.history.replaceState({}, '', url);

            // ✅ Recacher le bouton après reset
            button.style.display = 'none';
        });
    });
}
export {
    init
}